import { render, staticRenderFns } from "./OrderItemActFilesDialog.vue?vue&type=template&id=5a66ec7b"
import script from "./OrderItemActFilesDialog.vue?vue&type=script&lang=js"
export * from "./OrderItemActFilesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports